





















/* Created- 19 - Aug - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import ParticaCardDialog from "../Common/Container/ParticaDialogCard.vue";
import { IssueStorageDTO, IssueTrackingLogModel } from "../../Generated/ParticaAPI";
import { DateUtils } from "../../BusinessServices/dateutils";
@Component(
	{
		name: "IssueApiLog",
		components: { ParticaCardDialog }
	})
export default class IssueApiLog extends Vue {
	@Prop() private data: IssueTrackingLogModel[]; // your data   
	private search: string = "";
	private showstats: boolean = false;
	private headers: any[] = [
		{ text: "Logtime", value: "logtime", sortable: true },
		{ text: "Method", value: "method", sortable: true },
		{ text: "User", value: "user", sortable: true },
	];
	private getFormat(date: Date) {
		return date.toISOString();
	}
}



